import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { Constants } from 'shell-models-lib';

const envUrlOptions = [
    {
        label: 'https://login.salesforce.com',
        value: 'https://login.salesforce.com'
    },
    {
        label: 'https://test.salesforce.com',
        value: 'https://test.salesforce.com'
    }
];

export const envUrlControlMetadata: ControlMetadata = {
    type: 'parameterizable',
    child: {
        type: 'select',
        bind: 'environmentUrl',
        label: stringResources.ModelName_EnvironmentUrl,
        isLabelVertical: true,
        options: envUrlOptions,
        defaultValue: 'https://login.salesforce.com',
        warningMessageCalculator: (value: string) =>
            stringIsNullOrEmpty(value) || envUrlOptions.some((opt) => opt.value === value) ? '' : stringResources.infoSentViaUrlWarning,
        editable: true
    },
    warningMessageCalculator: (value: string) =>
        stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning
};

export const salesforceApiVersionControlMetadata: ControlMetadata = {
    type: 'parameterizable',
    child: {
        type: 'textbox',
        bind: 'apiVersion',
        label: stringResources.ModelName_SalesforceApiVersion,
        isLabelVertical: true,
        description: stringResources.Api_Version_Description,
        escapeDescription: false,
        required: true,
        placeholder: stringResources.Api_Version_Placeholder,
        validators: [
            {
                type: 'pattern',
                pattern: Constants.snowflakeApiVersionValidation.source,
                errorMessage: stringResources.Api_Version_Invalid_ValueMessage
            },
            { type: 'required', errorMessage: '' }
        ]
    }
};
